import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, Button, Chip, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, TextField } from "@mui/material";

import UndoIcon from "@mui/icons-material/Undo";

import moment from 'moment';

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { DownloadFile } from "../../helpers/DownloadFile";

import { usePages } from "../../hooks/usePages";

import { RootState } from "../../store";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";

import { Layout } from "../../components/Layout";

import { DialogExpediente } from "../../dialogs/DialogExpediente";

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerAutoridadesMaterias } from "../../connections/catalogos/AutoridadConnection";
import { ObtenerEtapa } from "../../connections/catalogos/EtapaConnection";
import { ObtenerSubEtapa } from "../../connections/catalogos/SubEtapaConnection";
import { ObtenerEstatus } from "../../connections/catalogos/EstatusConnection";
import { ConsultarExpedientesEtapaProcesal, DescargarExpedientesEtapaProcesal } from "../../connections/recepcion/ExpedienteConnection";

import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";
import { EtapaProps } from "../../interfaces/catalogos/EtapaInterface";
import { SubEtapaProps } from "../../interfaces/catalogos/SubEtapaInterface";
import { EstatusProps } from "../../interfaces/catalogos/EstatusInterface";
import { defaultExpediente, ExpedienteProps, ConsultaExpedienteEtapaDetalleProps, DescargarExpedientesEtapaProcesalParams } from "../../interfaces/recepcion/ExpedienteInterface";

export const ExpedientesEtapaProcesalPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );
    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [recordCount, setRecordCount] = useState( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [etapa, setEtapa] = useState( 0 );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );

    const [subEtapa, setSubEtapa] = useState( 0 );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );

    const [estatus, setEstatus] = useState( 0 );
    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>( [] );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [rows, setRows] = useState<ConsultaExpedienteEtapaDetalleProps[]>( [] );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setEtapa( 0 );
        setSubEtapa( 0 );
        setEstatus( 0 );
        setNumeroExpediente( '' );

        setRows( [ ] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );

        resetPage();
    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        const params: DescargarExpedientesEtapaProcesalParams = {
            idMateria: materia,
            idAutoridad: autoridad,
            idEtapa: etapa,
            idSubEtapa: subEtapa,
            idEstatus: estatus,
            numeroExpediente: numeroExpediente
        };

        await DescargarExpedientesEtapaProcesal( params ).then( resp => {

            if ( resp ) {

                setTimeout(() => {

                    DownloadFile( `Expedientes-Etapa-Procesal-${ Date.now() }.xlsx`, resp );

                    setLoadingDescargar( false );

                }, 700);

            }

        });

    }

    const handleVerDetalle = ( expediente: ExpedienteProps ) => {

        setExpedienteSeleccionado( expediente );
        setOpenDialogExpediente( true );

    };

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstatus().then( resp => {
                if ( resp ) setEstatusArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setSubEtapa( 0 );
            setSubEtapaArray( [] );

            if ( etapa !== 0 ) {
                await ObtenerSubEtapa( etapa ).then( resp => {
                    setSubEtapaArray( resp );
                });
            }

        }

        Obtener();

    }, [ etapa ]);

    useEffect(() => {

        async function Obtener(){

            setLoading( true );
            setRows( [ ] );

            await ConsultarExpedientesEtapaProcesal( { page, rowsPerPage, idMateria: 0, idAutoridad: 0, idEtapa: 0, idSubEtapa: 0, idEstatus: 0, numeroExpediente: '' } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp?.recordsCount ?? 0 );
                    setRows( resp?.records ?? [] );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener(){

            setLoading( true );
            setRows( [ ] );

            await ConsultarExpedientesEtapaProcesal( { page, rowsPerPage, idMateria: materia, idAutoridad: autoridad, idEtapa: etapa, idSubEtapa: subEtapa, idEstatus: estatus, numeroExpediente: numeroExpediente } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp?.recordsCount ?? 0 );
                    setRows( resp?.records ?? [] );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, etapa, subEtapa, estatus, numeroExpediente ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Expedientes por etapa procesal' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 } >

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Etapa</InputLabel>
                                        <Select
                                            label="Etapa"
                                            value={ etapa }
                                            onChange={ (e) => setEtapa( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                etapaArray.map( ({ idEtapa, descripcion }) => (
                                                    <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>SubEtapa</InputLabel>
                                        <Select
                                            label="SubEtapa"
                                            value={ subEtapa }
                                            onChange={ (e) => setSubEtapa( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado || etapa === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                subEtapaArray.map( ({ idSubEtapa, descripcion }) => (
                                                    <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Estatus</InputLabel>
                                        <Select
                                            label="Estatus"
                                            value={ estatus }
                                            onChange={ (e) => setEstatus( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                estatusArray
                                                .filter( ({ idEstatus }) => [5, 6].includes( idEstatus ) )
                                                .map(({ idEstatus, descripcion }) => (
                                                    <MenuItem key={ idEstatus } value={ idEstatus }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label='Número de expediente'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroExpediente }
                                        onChange={ (e) => setNumeroExpediente(e.target.value) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }} textAlign={ 'end' } alignContent={ 'center' }>
                                    <Button
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ !filtroAplicado && (materia === 0 && autoridad === 0 && etapa === 0 && subEtapa === 0 && estatus === 0 && numeroExpediente === '') }
                                        sx={{ mt: 1, px: 5 }}
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar'}
                                    </Button>
                                </Grid>
                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                  <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Fecha de inicio</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Actor(es)</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Demandado(s)</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Etapa</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Días / Mov.</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows
                                    .map( ( { numeroExpediente, expediente, fechaInicio, actores, demandados, idEtapa, etapa, subEtapa, dias, fechaUltimoMovimiento, idEstatus, estatus }, index ) => (

                                        <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    numeroExpediente
                                                    &&
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            sx={{ textTransform: 'none', fontWeight: 'bold' }}
                                                            onClick={ () => handleVerDetalle( expediente ) }
                                                        >
                                                            { numeroExpediente }
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1'>
                                                    { fechaInicio ? moment( fechaInicio ).format( 'DD-MM-YYYY' ) : '' }
                                                </Typography>

                                                <Typography variant='caption' color='text.secondary'>
                                                    { fechaInicio ? moment( fechaInicio ).format( 'hh:mm a' ) : '' }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' sx={{ textTransform: 'uppercase' }}>
                                                    { actores }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' sx={{ textTransform: 'uppercase' }}>
                                                    { demandados }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ etapa }</strong>
                                                </Typography>

                                                {
                                                    subEtapa
                                                    &&
                                                        <Typography variant='caption' display="block">
                                                            { subEtapa }
                                                        </Typography>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }} >

                                                {
                                                    fechaUltimoMovimiento
                                                    &&
                                                        <>
                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaUltimoMovimiento ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 1 }}>
                                                                { moment( fechaUltimoMovimiento ).format( 'hh:mm a' ) }
                                                            </Typography>
                                                        </>
                                                }

                                                {
                                                    ( dias > 0 && idEtapa !== 3 )
                                                    &&
                                                        <Chip
                                                            label={ `${ dias } día(s)` }
                                                            sx={{ fontWeight: 'bold', color: 'white' }}
                                                            color={ dias >= 100 ? 'error' : dias >= 50 ? 'warning' : 'primary' }
                                                        />
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }} >

                                                {
                                                    idEstatus !== 0
                                                    &&
                                                        <Chip
                                                            variant='filled'
                                                            color={ idEstatus === 6 ? 'primary' : 'default' }
                                                            sx={{ fontWeight: 'bold' }}
                                                            label={
                                                                <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }>
                                                                    { estatus }
                                                                </Typography>
                                                            }
                                                        />
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 7 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>
                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>
                                                <TableCell colSpan={ 7 } align="center">
                                                    <CircularProgress size={ 26 } />
                                                </TableCell>
                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 5 }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

        </Layout>
    )
}